jQuery(document).ready(function($) {

    //navigation
    $('nav.menu #open_menu_mobile ').on('click', function (event) {

        if( $("nav.menu").hasClass("isActive") ){
            $("nav.menu").removeClass("isActive")
            $("nav.menu .sections .section1").removeClass("isActive")
            $("nav.menu .sections .section2").removeClass("isActive")
            $("nav.menu .sections .section3").removeClass("isActive")
        }else{
            $("nav.menu").addClass("isActive")
            $("nav.menu .sections .section1").addClass("isActive")
        }
    })

    $('nav.menu .fond').on('click', function (event) {
        $('nav.menu #open_menu_mobile ').trigger("click")
    })


    $('nav.menu .sections .section1 a').on('mouseenter', function (event) {
        var cible = $(this).data("cible")

        $("nav.menu .sections .section2 .active").removeClass("active")
        if(cible){
            $("nav.menu .sections .section2 ."+cible).addClass("active")
            $("nav.menu .sections .section2").addClass("isActive")
        }else{
            $("nav.menu .sections .section2").removeClass("isActive")
        }
    })

    $('nav.menu .sections .section2 li').on('mouseenter', function (event) {
        var i = $(this).index() + 1
        $("nav.menu .sections .section3").addClass("isActive")
        $("nav.menu .sections .section3 .active").removeClass("active")

        $("nav.menu .sections .section3 .visuel"+i).addClass("active")
    })

    $('nav.menu .sections .section2').on( "mouseleave", function() {
        $("nav.menu .sections .section2").removeClass("isActive")
        $("nav.menu .sections .section3").removeClass("isActive")
    })

});